import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga'
import Ad from './Ad/Ad'
import Phone from './Phone/Phone'
import './Error.scss'

const checkRender = (prevProps, nextProps) => prevProps.error === nextProps.error

const Error = React.memo(({ error }) => {
  const phoneNumber = '1800-533-3669'
  const displayNumer = '1-800-JEFF-NOW'

  const phoneClick = () => {
    ReactGA.event({
      category: 'Appt Request',
      action: 'Click to Call',
      label: 'JeffNow'
    })
  }

  const renderDetails = () => {
    switch (error) {
    case ('callNow'):
      return 'For all other locations call your insurance provider'
    default:
      return ''
    }
  }

  const renderError = () => {
    switch (error) {
    case ('thankYou'):
      return <Ad />
    case ('knowMore'): case ('callNow'):
      return (
        <Fragment>
          <Phone
            isLink={true}
            number={phoneNumber}
            numberDisplay={displayNumer}
            phoneClick={phoneClick}
          />
          <div className="callInfo">
            {renderDetails()}
          </div>
        </Fragment>
      )
    case ('callVa'):
      return <Phone numberDisplay="Call your VA contact to check eligibility" />
    case ('noQualifyVa'):
      return <Phone numberDisplay="Call VA for an Appointment." />
    default:
      return ''
    }
  }

  return (
    <div className="error">
      {renderError()}
    </div>
  )
}, checkRender)

Error.propTypes = {
  error: PropTypes.string.isRequired
}

export default Error
